import { createReducer, on, createFeature } from '@ngrx/store'
import * as CityActions from './city.actions'
import { CityState } from './city.state'

const initialState: CityState = {
  cities: [],
  selectedCity: null,
  loading: false,
  error: null
}

export const cityReducer = createReducer(
  initialState,
  on(CityActions.loadCities, state => ({ ...state, loading: true })),
  on(CityActions.loadCitiesSuccess, (state, { cities }) => ({
    ...state,
    cities,
    loading: false,
    error: null
  })),
  on(CityActions.loadCityByIdSuccess, (state, { city }) => ({
    ...state,
    selectedCity: city,
    loading: false,
    error: null
  })),
  on(CityActions.loadFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error
  })),
  on(CityActions.clearCities, state => ({
    ...state,
    cities: []
  }))
)

// Create the feature for the business state
export const cityFeature = createFeature({
  name: 'city', // Feature name
  reducer: cityReducer
})
export type { CityState }
// Export the feature's selectors
export const { name, reducer, selectLoading, selectError } = cityFeature
